<template>
  <div class="page flex-col">
    <div class="box_1 flex-col">
      <div class="group_1 flex-row">
        <div class="group_2 flex-col justify-between">
          <img
            class="image_1"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/psgkssw3xur36mv6qj0uaycb115722ly03l89e779fd-16ed-484f-87c1-bca060e859e9"
          />
          <div class="text-wrapper_1 flex-row justify-between">
            <span class="text_01">{{ y1 }}</span>
            <span class="text_01">{{ y2 }}</span>
          </div>
        </div>
        <div class="text-wrapper_2 flex-col">
          <span class="text_3">机器人巡场报告</span>
        </div>
        <div class="group_3 flex-col">
          <div class="block_1 flex-row justify-between">
            <img
              class="image_2"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/psep5y988msrr82ly9dcfvh7dskdvvr8qbb3bdd42c3-3c3d-42eb-abaf-42bf78e6f22d"
            />
            <span class="text_4">元通智能</span>
          </div>
          <!-- <span class="text_5">乌山九巷B1停车场</span> -->
          <router-link :to="{ name: 'view5', query: { robotId: this.robotId } }"
          >
            <button class="homeBtn">首页</button>
          </router-link
          >
        </div>
      </div>
      <div class="group_4 flex-col">
        <div class="box_2 flex-row items-center">
          <!-- 消防设施 -->
          <div class="checkbox-group flex-row items-center">
            <input type="checkbox" class="thumbnail_1" v-model="fireFighting"/>
            <span class="text_6">消防设施</span>
          </div>

          <!-- 垃圾 -->
          <div class="checkbox-group flex-row items-center">
            <input type="checkbox" class="thumbnail_1" v-model="rubbish"/>
            <span class="text_7">垃圾</span>
          </div>

          <!-- 正常停放 -->
          <div class="checkbox-group flex-row items-center">
            <input type="checkbox" class="thumbnail_1" v-model="regularParking"/>
            <span class="text_9">正常停放</span>
          </div>

          <!-- 车位被占 -->
          <div class="checkbox-group flex-row items-center">
            <input type="checkbox" class="thumbnail_1" v-model="illegalParking"/>
            <span class="text_9">车位被占</span>
          </div>

          <!-- 非停放区被占 -->
          <div class="checkbox-group flex-row items-center">
            <input type="checkbox" class="thumbnail_1" v-model="nonParking"/>
            <span class="text_10">非停放区被占</span>
          </div>

          <div class="text-wrapper_3 flex-col">
            <span class="text_11">{{ nowQuest.startTime }}&nbsp;机器人巡场路线</span>
          </div>
        </div>

        <!-- <div class="image-wrapper_1 flex-row">
          <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/psouvbc719iv84sz7tq20l0t1qzmzxks68wfedaa8a1-b023-4992-a407-5c4ecfbcda33"
          />
        </div> -->
        <!--        <canvas-->
        <!--          ref="canvasPoint"-->
        <!--          class="image_4"-->
        <!--          :style="{-->
        <!--              backgroundImage: `url(${mapImageSrc})`,-->
        <!--            }"-->
        <!--          :width="kuandu"-->
        <!--          height="516"-->
        <!--        ></canvas>-->

        <div class="svg-wrapper" ref="wrapper" @wheel.prevent="handleWheel" @mousedown="startDrag"
             @mousemove="drag"
             @mouseup="endDrag"
             @mouseleave="endDrag">
          <!-- 带缩放的SVG容器 -->
          <div
            class="svg-container"
            :style="{ transform: `scale(${scale}) translate(${offsetX}px, ${offsetY}px)`, transformOrigin: 'top left' }"
          >
            <svg ref="svg" id="drawing-area"
                 xmlns="http://www.w3.org/2000/svg"
                 width="100%"
                 height="100%"
            >
              <rect id="backRect" :width="imgWidth" height="100%" fill="none" stroke="none" stroke-width="2"/>

              <image id="backImage" ref="image" :href=mapImageSrc height="100%"/>


              <g v-for="(rect, index) in regularParkingList" :key="'temp-' + index + '-' + rect[0]">
                <!-- 原长方形polygon -->
                <polygon
                  :points="rect"
                  fill="transparent"
                  stroke="transparent"
                  stroke-width="0.1"
                />

                <svg
                  t="1755651269146"
                  class="icon car-icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="8874"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  :width="getCarSize(rect)"
                  :height="getCarSize(rect)"
                  :x="getCarPosition(rect).x"
                  :y="getCarPosition(rect).y"
                  :transform="`rotate(${getCarRotation(rect)}, ${getCarPosition(rect).x + getCarSize(rect)/2}, ${getCarPosition(rect).y + getCarSize(rect)/2})`"
                >
                  <path
                    d="M231.982487 0.463458m199.477895-0.438675l19.231328-0.042292q199.477895-0.438676 199.91657 199.039219l1.37423 624.900328q0.438676 199.477895-199.039219 199.91657l-19.231328 0.042292q-199.477895 0.438676-199.91657-199.039219l-1.37423-624.900328q-0.438676-199.477895 199.039219-199.91657Z"
                    fill="#6BB92D" p-id="8875"
                  ></path>
                  <path
                    d="M278.793466 260.04778s164.975028-120.808856 326.81553-0.707036l-30.096158 146.709936a356.298925 356.298925 0 0 0-270.252664-1.838293zM312.471939 721.435798s142.750535 35.422495 261.461852-0.565628l0.377086 173.035236S430.711899 980.752975 312.849025 894.494603z"
                    fill="#383001" p-id="8876"
                  ></path>
                  <path
                    d="M651.330647 278.713526l35.681742 30.567516 0.023568 14.423531-35.634606-11.336141-0.070704-33.654906zM233.142519 279.632673L197.602184 310.365164l0.023568 14.399963 35.58747-11.477548-0.070703-33.654906z"
                    fill="#DBB61B" p-id="8877"
                  ></path>
                  <path
                    d="M233.189654 308.833253s43.364865 37.732146 43.553408 124.273332l0.707036 317.223411-28.917766-28.752791-0.77774-360.517572zM651.401351 307.890538s-43.176322 37.944256-42.987779 124.485443l0.707036 317.223411 28.75279-28.894197-0.777739-360.494005z"
                    fill="#383001" p-id="8878"
                  ></path>
                </svg>
              </g>


              <g v-for="(rect, index) in illegalParkingList" :key="'temp-' + index + '-' + rect[0]">
                <!-- 原长方形polygon -->
                <polygon
                  :points="rect"
                  fill="transparent"
                  stroke="transparent"
                  stroke-width="0.1"
                />

                <svg
                  t="1755651269146"
                  class="icon car-icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="8874"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  :width="getCarSize(rect)"
                  :height="getCarSize(rect)"
                  :x="getCarPosition(rect).x"
                  :y="getCarPosition(rect).y"
                  :transform="`rotate(${getCarRotation(rect)}, ${getCarPosition(rect).x + getCarSize(rect)/2}, ${getCarPosition(rect).y + getCarSize(rect)/2})`"
                >
                  <path
                    d="M231.982487 0.463458m199.477895-0.438675l19.231328-0.042292q199.477895-0.438676 199.91657 199.039219l1.37423 624.900328q0.438676 199.477895-199.039219 199.91657l-19.231328 0.042292q-199.477895 0.438676-199.91657-199.039219l-1.37423-624.900328q-0.438676-199.477895 199.039219-199.91657Z"
                    fill="#E76C13" p-id="8875"
                  ></path>
                  <path
                    d="M278.793466 260.04778s164.975028-120.808856 326.81553-0.707036l-30.096158 146.709936a356.298925 356.298925 0 0 0-270.252664-1.838293zM312.471939 721.435798s142.750535 35.422495 261.461852-0.565628l0.377086 173.035236S430.711899 980.752975 312.849025 894.494603z"
                    fill="#383001" p-id="8876"
                  ></path>
                  <path
                    d="M651.330647 278.713526l35.681742 30.567516 0.023568 14.423531-35.634606-11.336141-0.070704-33.654906zM233.142519 279.632673L197.602184 310.365164l0.023568 14.399963 35.58747-11.477548-0.070703-33.654906z"
                    fill="#DBB61B" p-id="8877"
                  ></path>
                  <path
                    d="M233.189654 308.833253s43.364865 37.732146 43.553408 124.273332l0.707036 317.223411-28.917766-28.752791-0.77774-360.517572zM651.401351 307.890538s-43.176322 37.944256-42.987779 124.485443l0.707036 317.223411 28.75279-28.894197-0.777739-360.494005z"
                    fill="#383001" p-id="8878"
                  ></path>
                </svg>
              </g>


              <polyline :points="trajectoryPoints" fill="none" stroke="#50C0E1" stroke-width="2"/>


              <g v-if="fireFighting && facilityList.length > 0&&fireFighting==true">
                <!-- 循环渲染每个消防设施 -->
                <g v-for="(facility, index) in facilityList" :key="'fire-facility-' + facility.id + '-' + index">
                  <!-- 消防设施图标：复用图例的 label_13 图片 -->
                  <image
                    class="fire-facility-icon"
                    :x="facility.x"
                  :y="facility.y"
                  :width="14"
                  :height="17"
                  :href="facility.src"
                  referrerpolicy="no-referrer"
                  />

                  <!-- 可选：消防设施名称（显示在图标下方，保持样式统一） -->

                </g>
              </g>

              <g v-if="facilityList2 && facilityList2.length > 0&&rubbish==true">
                <!-- 循环渲染每个消防设施 -->
                <g v-for="(facility, index) in facilityList2" :key="'fire-facility-' + facility.id + '-' + index">
                  <!-- 消防设施图标：复用图例的 label_13 图片 -->
                  <image
                    class="fire-facility-icon"
                    :x="facility.x"
                    :y="facility.y"
                    :width="14"
                    :height="17"
                    :href="facility.src"
                    referrerpolicy="no-referrer"
                  />

                  <!-- 可选：消防设施名称（显示在图标下方，保持样式统一） -->

                </g>
              </g>




              <image :x="this.robotX" :y="this.robotY" :transform="this.robotAngleStr" xlink:href="robotGo.png"
                     width="16"
                     height="16"
              />
            </svg>
          </div>
        </div>

      </div>
      <div class="text-wrapper_4 flex-row">
        <span class="text_12">巡检内容</span>
        <span class="text_13">当前巡检报告</span>
        <span class="text_14">上一次巡检报告</span>
      </div>
      <div class="group_6 flex-row justify-between">
        <div class="block_2 flex-col">
          <div class="text-wrapper_5 flex-row">
            <span class="text_15">启动时间</span>
            <span class="text_16">{{ nowQuest.startTime }}</span>
            <span class="text_17">{{ lastQuest.startTime }}</span>
          </div>
          <div class="text-wrapper_6 flex-row">
            <span class="text_18">剩余/预计总用时</span>
            <span class="text_19">{{ nowQuest.duration }}</span>
            <span class="text_20">{{ lastQuest.duration }}</span>
          </div>
          <div class="text-wrapper_7 flex-row">
            <span class="text_21">设备状态</span>
            <span class="text_22" v-if="nowQuest.status == 0">正常</span>
            <span class="text_22" v-if="nowQuest.status == 1">故障</span>
            <span class="text_22" v-if="nowQuest.status == 2">告警</span>
            <span class="text_23" v-if="lastQuest.status == 0">正常</span>
            <span class="text_23" v-if="lastQuest.status == 1">故障</span>
            <span class="text_23" v-if="lastQuest.status == 2">告警</span>
          </div>
          <div class="text-wrapper_8 flex-row">
            <span class="text_24">巡场进度</span>
            <span class="text_25">{{ nowQuest.finish }}</span>
            <span class="text_26">{{ lastQuest.finish }}</span>
          </div>
          <div class="text-wrapper_8 flex-row">
            <span class="text_24">正常停放车辆数</span>
            <span class="text_25">{{ nowQuest.trueParkings }}</span>
            <span class="text_26">{{ lastQuest.trueParkings }}</span>
          </div>
          <div class="text-wrapper_8 flex-row">
            <span class="text_24">乱停乱放车辆数</span>
            <span class="text_25">{{ nowQuest.illegalParkings }}</span>
            <span class="text_26">{{ lastQuest.illegalParkings }}</span>
          </div>
          <!-- <div class="list_1 flex-row">
            <div
              class="text-wrapper_9 flex-col justify-between"
              v-for="(item, index) in loopData0"
              :key="index"
            >
              <span class="text_27" v-html="item.lanhutext0"></span>
              <span class="text_28" v-html="item.lanhutext1"></span>
            </div>
          </div> -->
          <!-- <div class="text-wrapper_10 flex-row">
            <span class="text_29">巡场进度</span>
            <span class="text_30">{{ nowQuest.gg }}</span>
            <span class="text_31">{{ lastQuest.gg }}</span>
          </div> -->
        </div>
        <div class="block_3 flex-col">
          <div class="image-text_1 flex-row justify-between">
            <img
              class="label_13"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/pstrrqr6i8qnl68rib7uq4rnggkypayxsrq2515dd84-3cc8-4d9e-870e-86e6ff84bb14"

            />
            <span class="text-group_1">消防设施</span>
          </div>
          <div class="section_1 flex-row justify-between">
            <img
              class="label_14"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps0iuxixsdqoyuvvhz54waiia85z8vzpv4id13b44b1a-ccb9-498b-a4f6-08e0205b2f4b"
            />
            <span class="text_32">垃圾</span>
          </div>
          <div class="image-text_2 flex-row justify-between">
            <!--            <img-->
            <!--              class="label_15"-->
            <!--              referrerpolicy="no-referrer"-->
            <!--              src="https://lanhu.oss-cn-beijing.aliyuncs.com/psuq7ymr0zqcbwfp4x4im7gqpnpofoppntca0821c2-e8ac-422c-8324-90e1485a0b25"-->
            <!--            />-->
            <svg
              t="1755651269146"
              class="label_15"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="8874"
              style="width: 24px; height: 24px;"
            >
              <path
                d="M231.982487 0.463458m199.477895-0.438675l19.231328-0.042292q199.477895-0.438676 199.91657 199.039219l1.37423 624.900328q0.438676 199.477895-199.039219 199.91657l-19.231328 0.042292q-199.477895 0.438676-199.91657-199.039219l-1.37423-624.900328q-0.438676-199.477895 199.039219-199.91657Z"
                fill="#6BB92D" p-id="8875"
              ></path>
              <path
                d="M278.793466 260.04778s164.975028-120.808856 326.81553-0.707036l-30.096158 146.709936a356.298925 356.298925 0 0 0-270.252664-1.838293zM312.471939 721.435798s142.750535 35.422495 261.461852-0.565628l0.377086 173.035236S430.711899 980.752975 312.849025 894.494603z"
                fill="#383001" p-id="8876"
              ></path>
              <path
                d="M651.330647 278.713526l35.681742 30.567516 0.023568 14.423531-35.634606-11.336141-0.070704-33.654906zM233.142519 279.632673L197.602184 310.365164l0.023568 14.399963 35.58747-11.477548-0.070703-33.654906z"
                fill="#DBB61B" p-id="8877"
              ></path>
              <path
                d="M233.189654 308.833253s43.364865 37.732146 43.553408 124.273332l0.707036 317.223411-28.917766-28.752791-0.77774-360.517572zM651.401351 307.890538s-43.176322 37.944256-42.987779 124.485443l0.707036 317.223411 28.75279-28.894197-0.777739-360.494005z"
                fill="#383001" p-id="8878"
              ></path>
            </svg>
            <span class="text-group_2">正常停放</span>
          </div>
          <div class="image-text_2 flex-row justify-between">
<!--            <img-->
<!--              class="label_15"-->
<!--              referrerpolicy="no-referrer"-->
<!--              src="https://lanhu.oss-cn-beijing.aliyuncs.com/psuq7ymr0zqcbwfp4x4im7gqpnpofoppntca0821c2-e8ac-422c-8324-90e1485a0b25"-->
<!--            />-->
            <svg
              t="1755651269146"
              class="label_15"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="8874"
              style="width: 24px; height: 24px;"
            >
              <path
                d="M231.982487 0.463458m199.477895-0.438675l19.231328-0.042292q199.477895-0.438676 199.91657 199.039219l1.37423 624.900328q0.438676 199.477895-199.039219 199.91657l-19.231328 0.042292q-199.477895 0.438676-199.91657-199.039219l-1.37423-624.900328q-0.438676-199.477895 199.039219-199.91657Z"
                fill="#E76C13" p-id="8875"
              ></path>
              <path
                d="M278.793466 260.04778s164.975028-120.808856 326.81553-0.707036l-30.096158 146.709936a356.298925 356.298925 0 0 0-270.252664-1.838293zM312.471939 721.435798s142.750535 35.422495 261.461852-0.565628l0.377086 173.035236S430.711899 980.752975 312.849025 894.494603z"
                fill="#383001" p-id="8876"
              ></path>
              <path
                d="M651.330647 278.713526l35.681742 30.567516 0.023568 14.423531-35.634606-11.336141-0.070704-33.654906zM233.142519 279.632673L197.602184 310.365164l0.023568 14.399963 35.58747-11.477548-0.070703-33.654906z"
                fill="#DBB61B" p-id="8877"
              ></path>
              <path
                d="M233.189654 308.833253s43.364865 37.732146 43.553408 124.273332l0.707036 317.223411-28.917766-28.752791-0.77774-360.517572zM651.401351 307.890538s-43.176322 37.944256-42.987779 124.485443l0.707036 317.223411 28.75279-28.894197-0.777739-360.494005z"
                fill="#383001" p-id="8878"
              ></path>
            </svg>
            <span class="text-group_2">车位被占</span>
          </div>
          <div class="image-text_3 flex-row justify-between">
            <img
              class="label_16"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/psxg831it3qoipeow8l303eijlv1l77ead4c8d39f-d3ff-4584-af39-5b626bc33bda"
            />
            <span class="text-group_3">巡检路线</span>
          </div>
          <router-link :to="{ name: 'view13', query: { robotId: robotId } }">
            <div class="text-wrapper_11 flex-col">
              <span class="text_33">查看全部巡场报告</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {get, post} from "@/util/axios";

var that;
var interval1;
var interval2;
export default {
  data() {
    return {
      robotId: 0,
      y1: "",
      y2: "",
      fireFacilityIconSrc: "https://lanhu.oss-cn-beijing.aliyuncs.com/pstrrqr6i8qnl68rib7uq4rnggkypayxsrq2515dd84-3cc8-4d9e-870e-86e6ff84bb14",
      fireFacilityIconSrc2: "https://lanhu.oss-cn-beijing.aliyuncs.com/ps0iuxixsdqoyuvvhz54waiia85z8vzpv4id13b44b1a-ccb9-498b-a4f6-08e0205b2f4b",
      fireFighting: true,
      rubbish: true,
      regularParking: true,
      illegalParking: true,
      nonParking: true,
      nowQuest: {},
      lastQuest: {},
      facilityList: [],
      facilityList2: [],
      regularParkingList: [],
      illegalParkingList: [],
      mapImageSrc: "",
      trajectoryPoints: '',
      kuandu: null,
      yuantuHeight: null,
      robotAngleStr:'',
      //-------------
      scale: 1,
      scaleStep: 0.05,
      minScale: 0.2,
      maxScale: 5,
      offsetX: 0,
      offsetY: 0,
      isDragging: false,
      lastMouseX: 0,
      lastMouseY: 0,
      imgHeight: 0,
      imgWidth: 0,
      mapOHeight: 0,
      mapOWeight: 0,
      robotX: 0,
      robotY: 0,

    };
  },
  watch: {
    fireFighting() {
      this.getThreeMovePoint();
    },
    rubbish() {
      this.getThreeMovePoint();
    },
    regularParking() {
      this.getThreeMovePoint();
      this.getThreeSpot();
    },
    illegalParking() {
      this.getThreeMovePoint();
      this.getThreeSpot();
    },
    nonParking() {
      this.getThreeMovePoint();
    },
  },
  mounted() {
    that = this;
    interval1 = setInterval(function () {
      that.getTime();
    }, 1000);
    interval2 = setInterval(function () {
      that.taskInfo();
      that.getThreeSpot();
      that.getThreeMovePoint();
    }, 20000);
    // that.nowTaskInfo();
    // that.lastTaskInfo();
    that.getImageSize();
    window.addEventListener('resize', this.updateImageSize)
    that.getThreeMap();
    that.taskInfo();
    that.getThreeSpot();
    that.getMapFacility();
    that.getThreeMovePoint();
    this.setCurrentRobot();
  },
  created() {
    if (this.$route.query.robotId) {
      this.robotId = this.$route.query.robotId;
    }
  },
  beforeDestroy() {
    // 清除所有定时器
    if (interval1) {
      clearInterval(interval1);
      interval1 = null;
    }
    if (interval2) {
      clearInterval(interval2);
      interval2 = null;
    }
    window.removeEventListener('resize', this.updateImageSize)
  },
  methods: {
    processX(x, y) {
      let result = 0;
      if (this.robotId === '4' ) {
        //result = parseFloat(x) * 20.01223990208078 + 305;
        result = 1956.481 - 30.653 * parseFloat(x) - 1.484 * parseFloat(y);
      } else if (this.robotId === '5') {
        // result = 470.02 - 1.65 * parseFloat(x) + 28.37 * parseFloat(y);
        result = 1.3600 * parseFloat(x) + 28.0353 * parseFloat(y) + 516.9969;
      } else if (this.robotId === '6') {
        result = 32.19 * parseFloat(x) + 0.27 * parseFloat(y) + 654.13;
      }else if(this.robotId==='3'){
        result = 21.148 * parseFloat(x) -0.047* parseFloat(y) +291.99;
      }else if(this.robotId==='16'){
        result = 21.148 * parseFloat(x) -0.047* parseFloat(y) +291.99;
      } else if(this.robotId==='171'||this.robotId ==='176'){
        result = 21.148 * parseFloat(x) -0.047* parseFloat(y) +291.99;
      } else if(this.robotId==='172'){
        result = 8.7397 * parseFloat(x) + 0.0310 * parseFloat(y) + 990.1399;
      }else if(this.robotId==='173'){
        result = 8.629198 * parseFloat(x) + 0.179402 * parseFloat(y) + 1031.738509;
      }else if(this.robotId==='174'){
        result =6.482605 * parseFloat(x) + -5.315920 * parseFloat(y) + 1255.838351;
      }else if(this.robotId==='175'){
        result =  8.502007* parseFloat(x)+ 0.224816* parseFloat(y) + 1644.672657
      }else if(this.robotId==='179'){
        result =  1.531345* parseFloat(x)+-79.237351* parseFloat(y) + 5613.439004
      }else if(this.robotId==='180'){
        result = 0.010528* parseFloat(x) + 41.337585* parseFloat(y) + 5635.606116
      }
      return parseFloat(result.toFixed(1));
    },
    processY(x, y) {
      let result = 0;
      if ( this.robotId === '4') {
        //result = 1846 - parseFloat(y) * 20.00797925393976;
        result = -0.487 * parseFloat(x) + 26.395 * parseFloat(y) + 1213.689;
      } else if (this.robotId === '5') {
        // result = 634.01 + 21.81 * parseFloat(x) + 0.88 * parseFloat(y);
        result = 21.8067 * parseFloat(x) - 1.1227 * parseFloat(y) + 685.5309
      } else if (this.robotId === '6') {
        result = 0.22 * parseFloat(x) - 24.47 * parseFloat(y) + 1792.07
      }else if(this.robotId ==='3'){
        result = -1.039 * parseFloat(x) -19.654 * parseFloat(y) +1837.336
      }else if(this.robotId ==='171'||this.robotId ==='176'){
        result = -1.039 * parseFloat(x) -19.654 * parseFloat(y) +1837.336
      } else if(this.robotId ==='16'){
        result = -1.039 * parseFloat(x) -19.654 * parseFloat(y) +1837.336
      }else if(this.robotId ==='172') {
        result = 0.0188 * parseFloat(x) + -8.6130 * parseFloat(y) + 1060.6248;
      }else if(this.robotId ==='173') {
        result = 0.439786 * parseFloat(x) + -8.710597 * parseFloat(y) + 916.141851;
      }else if(this.robotId ==='174'){
        result =-5.350924 * parseFloat(x) + -6.551079 * parseFloat(y) +762.524563;
      }else if(this.robotId ==='175'){
        result =0.300449* parseFloat(x) + -8.331543* parseFloat(y) + 736.924314
      }else if(this.robotId==='179'){
        result = -79.848067* parseFloat(x) + -3.167545* parseFloat(y) + 3081.612555
      }else if(this.robotId==='180'){
        result =  41.498730* parseFloat(x)  + -0.006519* parseFloat(y) + 1445.183727
      }
      return parseFloat(result.toFixed(1));
    },
    async setCurrentRobot() {
      await get("/threeBigscreen/getRobotInfo/" + this.robotId, {}).then((response) => {
        //根据位置信息绘制 角度图
        const ponitMidX = response.data.mFcurx
        const pointMidY = response.data.mFcury
        const svgMidX = (this.processX(ponitMidX, pointMidY) * (this.imgWidth / this.mapOWeight))
        const svgMidY = (this.processY(ponitMidX, pointMidY) * (this.imgHeight / this.mapOHeight))
        this.robotX = svgMidX - 8
        this.robotY = svgMidY - 8
        this.oRobotX = svgMidX;
        this.oRobotY = svgMidY;
        let robotAngle;
        if (this.robotId == 3 || this.robotId == 4) {
          robotAngle = (2 * Math.PI - response.data.mFcuryaw) / (2 * Math.PI) * 360 + 180;
        } else if (this.robotId == 5) {
          robotAngle = (2 * Math.PI - response.data.mFcuryaw) / (2 * Math.PI) * 360 + 95;
        } else if (this.robotId == 6) {
          robotAngle = (2 * Math.PI - response.data.mFcuryaw) / (2 * Math.PI) * 360;
        }else if (this.robotId == 173) {
          robotAngle = (2 * Math.PI - response.data.mFcuryaw) / (2 * Math.PI) * 360;
        }
        else if (this.robotId == 6) {
          robotAngle = (2 * Math.PI - response.data.mFcuryaw) / (2 * Math.PI) * 360;
        }
        this.robotAngleStr = 'rotate(' + robotAngle + ', ' + svgMidX + ', ' + svgMidY + ')';
      })
    },

    getThreeMap() {
      console.log("加载地图");
      get("/threeBigscreen/getThreeMap", {
        robotId: this.robotId,
      }).then((res) => {

        this.mapOWeight = res.data.mapX;
        this.mapOHeight = res.data.mapY;
        this.mapImageSrc = res.data.mapUrl;
        this.yuantuHeight = (res.data.mapY / 516);
        this.kuandu = (res.data.mapX / this.yuantuHeight).toFixed(2);
      });
    },
    getMapFacility() {
      console.log("加载消防设施");
      get("/threeBigscreen/getMapFacility/" + this.robotId, {}).then((res) => {

        if(this.imgWidth===0){
          return;
        }
        const realWidth = (this.mapOWeight * this.imgHeight) / this.mapOHeight;
        const x = (this.imgWidth - realWidth) / 2;
        const totalList = res.data;
        for (let totalListKey in totalList) {
          const currentPoint = totalList[totalListKey];
          let src = '';


          if(currentPoint.facilityName!=null&&currentPoint.facilityName.includes("消防")){
            src= this.fireFacilityIconSrc;
          }else{
            src = this.fireFacilityIconSrc2;
          }
          const point = {
            id:currentPoint.facilityId,
            x:this.processX(currentPoint.positionX, currentPoint.positionY)*(this.imgHeight / this.mapOHeight) +x,
            y:this.processY(currentPoint.positionX, currentPoint.positionY)*(this.imgHeight / this.mapOHeight),
            src:src,
          }

          if(currentPoint.facilityName!=null&&currentPoint.facilityName.includes("消防")){
            this.facilityList.push(point)
          }else{
            this.facilityList2.push(point)
          }

        }





      });
    },
    getThreeSpot() {
      console.log("车位信息");
      get("/threeBigscreen/getThreeSpot", {
        robotId: this.robotId
      }).then((spotRes) => {

        if (this.imgWidth === 0) {
          return;
        }
        const realWidth = (this.mapOWeight * this.imgHeight) / this.mapOHeight;
        const x = (this.imgWidth - realWidth) / 2;

        if (Array.isArray(spotRes.data[0]) && spotRes.data[0].length > 0&&this.regularParking === true) {
          this.regularParkingList = spotRes.data[0].map(item => [
            (this.processX(item.parkX1, item.parkY1) * (this.imgHeight / this.mapOHeight)) + x, (this.processY(item.parkX1, item.parkY1) * (this.imgHeight / this.mapOHeight)),
            (this.processX(item.parkX2, item.parkY2) * (this.imgHeight / this.mapOHeight)) + x, (this.processY(item.parkX2, item.parkY2) * (this.imgHeight / this.mapOHeight)),
            (this.processX(item.parkX3, item.parkY3) * (this.imgHeight / this.mapOHeight)) + x, (this.processY(item.parkX3, item.parkY3) * (this.imgHeight / this.mapOHeight)),
            (this.processX(item.parkX4, item.parkY4) * (this.imgHeight / this.mapOHeight)) + x, (this.processY(item.parkX4, item.parkY4) * (this.imgHeight / this.mapOHeight))
          ]);
        } else {
          this.regularParkingList = [];
        }


        if (Array.isArray(spotRes.data[1]) && spotRes.data[1].length > 0&&this.illegalParking === true) {
          this.illegalParkingList = spotRes.data[1].map(item => [
            (this.processX(item.parkX1, item.parkY1) * (this.imgHeight / this.mapOHeight)) + x, (this.processY(item.parkX1, item.parkY1) * (this.imgHeight / this.mapOHeight)),
            (this.processX(item.parkX2, item.parkY2) * (this.imgHeight / this.mapOHeight)) + x, (this.processY(item.parkX2, item.parkY2) * (this.imgHeight / this.mapOHeight)),
            (this.processX(item.parkX3, item.parkY3) * (this.imgHeight / this.mapOHeight)) + x, (this.processY(item.parkX3, item.parkY3) * (this.imgHeight / this.mapOHeight)),
            (this.processX(item.parkX4, item.parkY4) * (this.imgHeight / this.mapOHeight)) + x, (this.processY(item.parkX4, item.parkY4) * (this.imgHeight / this.mapOHeight))
          ]);
        } else {
          this.illegalParkingList = [];
        }


      });
    },
    async getThreeMovePoint() {
      console.log("加载行走路线");
      that = this;
      const self = this;
      let data;
      try {
        // 等待异步请求完成
        const res = await get(`/threeBigscreen/taskInfo/${this.robotId}`, {});
        data = res.data;
      } catch (error) {
        console.error("请求出错:", error);
        return;
      }
      // 将第一个时间字符串转换为时间戳
      const date1 = new Date(data.startTime.replace(" ", "T")); // 替换空格以适配 Date 格式
      const timestamp1 = Math.floor(date1.getTime()); // 转换为秒级时间戳
      // 从第二个字符串解析天、小时、分钟
      const days = parseInt(data.duration.match(/(\d+)天/)[1], 10) || 0;
      const hours = parseInt(data.duration.match(/(\d+)小时/)[1], 10) || 0;
      const minutes = parseInt(data.duration.match(/(\d+)分钟/)[1], 10) || 0;
      const timeDelta = (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60) * 1000;
      const timestamp2 = Math.floor((date1.getTime() + timeDelta));
      get("/threeBigscreen/getThreeMovePointByTime", {
        robotId: this.robotId,
        startTime: timestamp1,
        endTime: timestamp2
      }).then((res) => {

          if (this.imgWidth === 0) {
            return;
          }

          const realWidth = (this.mapOWeight * this.imgHeight) / this.mapOHeight;
          const x = (this.imgWidth - realWidth) / 2;

          if (res && res.data && Array.isArray(res.data.pointList) && res.data.pointList.length > 0) {
            const newXunipoint = res.data.pointList.map((point) => ({
              pointX: (this.processX(point.pointX, point.pointY) * (this.imgHeight / this.mapOHeight)) + x,
              pointY: (this.processY(point.pointX, point.pointY) * (this.imgHeight / this.mapOHeight))
            }));
            this.trajectoryPoints = newXunipoint.map(p => `${p.pointX},${p.pointY}`).join(' ');

          } else {
            this.trajectoryPoints = '';
          }
          const lastPoint = res.data.pointList[res.data.pointList.length - 1];
          this.robotX = this.processX(lastPoint.pointX, lastPoint.pointY) * (this.imgHeight / this.mapOHeight) + x - 8;
          this.robotY = this.processY(lastPoint.pointX, lastPoint.pointY) * (this.imgHeight / this.mapOHeight) - 8;
          this.yaw = lastPoint.pointYaw;
          //

        }
      );
    },
    lastTaskInfo() {
      console.log("获取上一次任务");
      get("/threeBigscreen/lastTaskInfo/" + this.robotId, {}).then((res) => {
        this.lastQuest = res.data;
      });
    },
    nowTaskInfo() {
      console.log("获取当前任务");
      get("/threeBigscreen/taskInfo/" + this.robotId, {}).then((res) => {
        this.nowQuest = res.data;
      });
    },
    // 处理鼠标滚轮事件
    handleWheel(event) {
      // 计算鼠标相对于包装器的位置
      const rect = this.$refs.wrapper.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;

      // 确定缩放方向：向下滚动为缩小，向上滚动为放大
      const zoomIn = event.deltaY < 0;

      // 保存旧的缩放比例
      const oldScale = this.scale;

      // 计算新的缩放比例
      let newScale;
      if (zoomIn) {
        newScale = this.scale + this.scaleStep;
      } else {
        newScale = this.scale - this.scaleStep;
      }

      // 限制缩放范围
      newScale = Math.max(this.minScale, Math.min(this.maxScale, newScale));

      // 应用新的缩放比例
      this.scale = newScale;

      // 调整偏移量以保持鼠标位置下的点不变
      // 这样可以实现以鼠标为中心点的缩放
      if (oldScale !== newScale) {
        // 计算鼠标位置在缩放前的坐标
        const beforeX = (mouseX / oldScale) - this.offsetX;
        const beforeY = (mouseY / oldScale) - this.offsetY;

        // 计算鼠标位置在缩放后应该对应的坐标
        const afterX = (mouseX / newScale) - beforeX;
        const afterY = (mouseY / newScale) - beforeY;

        // 更新偏移量
        this.offsetX += (afterX - this.offsetX);
        this.offsetY += (afterY - this.offsetY);
      }

      // 发出缩放变化事件
      this.$emit('scale-change', this.scale);
    },
    startDrag(event) {
      this.isDragging = true;
      this.lastMouseX = event.clientX;
      this.lastMouseY = event.clientY;
      // 改变光标样式为抓取中
      this.$refs.wrapper.style.cursor = 'grabbing';
    },
    drag(event) {
      if (!this.isDragging) return;

      // 计算鼠标移动距离
      const deltaX = event.clientX - this.lastMouseX;
      const deltaY = event.clientY - this.lastMouseY;

      // 更新偏移量（注意要除以缩放比例，因为在缩放后移动距离也会受到影响）
      this.offsetX += deltaX / this.scale;
      this.offsetY += deltaY / this.scale;

      // 更新最后鼠标位置
      this.lastMouseX = event.clientX;
      this.lastMouseY = event.clientY;
    },

    // 结束拖拽
    endDrag() {
      this.isDragging = false;
      // 恢复光标样式为可抓取
      this.$refs.wrapper.style.cursor = 'grab';
    },
    getImageSize() {
      const imgElement = this.$refs.image

      imgElement.onload = () => {
        this.imgWidth = imgElement.getBoundingClientRect().width
        this.imgHeight = imgElement.getBoundingClientRect().height
        this.getThreeSpot()
        this.getThreeMovePoint();
        this.getMapFacility();

      }
      if (imgElement.complete) {
        imgElement.onload()
      }
    },
    updateImageSize() {
      const imgElement = this.$refs.image
      this.imgWidth = imgElement.getBoundingClientRect().width
      this.imgHeight = imgElement.getBoundingClientRect().height
      this.resetDrawPic();
      this.getThreeMovePoint();
      this.getThreeSpot();

    },
    async taskInfo() {
      console.log("获取任务和上一次任务");
      const res = await get(`/threeBigscreen/taskInfo/${this.robotId}`, {});
      this.nowQuest = res.data;
      get("/threeBigscreen/getLastTaskInfo/", {
        robotId: this.robotId,
        taskId: this.nowQuest.taskId
      }).then((res) => {
        this.lastQuest = res.data;
      });
    },
    getCarSize(rectPoints) {
      const xs = [rectPoints[0], rectPoints[2], rectPoints[4], rectPoints[6]];
      const ys = [rectPoints[1], rectPoints[3], rectPoints[5], rectPoints[7]];
      const width = Math.max(...xs) - Math.min(...xs);
      const height = Math.max(...ys) - Math.min(...ys);

      // 取车位短边的70%作为小车尺寸（确保在两种方向都不溢出）
      const minSide = Math.min(width, height);
      return minSide * 1.4; // 70%比例可根据视觉效果调整 // 假设x1和x2是水平方向的两个点
      // 小车大小设为宽度的60%，最大不超过30px（可根据需要调整）
    },
    getCarPosition(rectPoints) {

      // 解析polygon的points属性（格式如 "x1,y1 x2,y2 x3,y3 x4,y4"）
      const xs = [rectPoints[0], rectPoints[2], rectPoints[4], rectPoints[6]];
      // 提取所有y坐标（索引1、3、5、7）
      const ys = [rectPoints[1], rectPoints[3], rectPoints[5], rectPoints[7]];


      const minX = Math.min(...xs); // 长方形左上角x
      const maxX = Math.max(...xs); // 长方形右下角x
      const minY = Math.min(...ys); // 长方形左上角y
      const maxY = Math.max(...ys); // 长方形右下角y

      // 计算长方形中心点坐标
      const centerX = (minX + maxX) / 2;
      const centerY = (minY + maxY) / 2;

      // 计算小车的偏移量（让小车居中，需减去自身宽高的一半）
      const carSize = this.getCarSize(rectPoints); // 复用现有计算大小的方法
      return {
        x: centerX - carSize / 2, // 水平居中
        y: centerY - carSize / 2  // 垂直居中
      };
    },
    getCarRotation(rect) {
      // rect是一维数组：[x1,y1,x2,y2,x3,y3,x4,y4]
      // 计算车位的宽和高（取最大差值）
      const xs = [rect[0], rect[2], rect[4], rect[6]];
      const ys = [rect[1], rect[3], rect[5], rect[7]];
      const width = Math.max(...xs) - Math.min(...xs); // 车位宽度
      const height = Math.max(...ys) - Math.min(...ys); // 车位高度

      // 横向车位（宽>高）：小车旋转90度；纵向车位：不旋转
      return width > height ? 90 : 0;
    },
    getTime() {
      var date = new Date();
      var year = date.getFullYear();
      var mon = date.getMonth() + 1;
      var da = date.getDate(); //获取当前日

      var day = date.getDay();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      var submitTime = "";
      submitTime += year + "-";
      if (mon >= 10) {
        // submitTime += mon + "-";
      } else {
        mon = "0" + mon;
      }
      if (da >= 10) {
        // submitTime += day;
      } else {
        da = "0" + da;
      }
      submitTime += " ";
      if (h >= 10) {
        // submitTime += h + ":";
      } else {
        h = "0" + h;
      }
      if (m >= 10) {
        // submitTime += m;
      } else {
        m = "0" + m;
      }
      if (s < 10) {
        s = "0" + s;
      }
      var weeks = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      );
      this.y1 = year + "年" + mon + "月" + da + "日";
      this.y2 = weeks[day] + " " + h + ":" + m + ":" + s;
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  position: relative;
  width: 1980px;
  height: 1080px;
  overflow: hidden;
}

.logoWu {
  width: 25px;
  height: 25px;
}

.homeBtn {
  color: #ffffff;
  position: absolute;
  left: 1800px;
  top: 80px;
  width: 100px;
  height: 40px;
  background: url("../assets/按钮.png");
  background-size: contain;
  background-repeat: no-repeat;
}

.text_01 {
  width: 146px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.box_1 {
  width: 1980px;
  height: 1080px;
  background: url(~@/assets/image/psf7pti8mol8e9fq6s4jknuve543n8huz35b147531f-6eae-4e28-af51-b968fec96002.png) 100% no-repeat;
  background-size: 100% 100%;
}

.group_1 {
  width: 1923px;
  height: 105px;
}

.group_2 {
  width: 350px;
  height: 43px;
  margin-top: 38px;
}

.image_1 {
  width: 288px;
  height: 3px;
}

.text-wrapper_1 {
  width: 339px;
  height: 19px;
  margin: -30px 0 10px 11px;
}

.text_1 {
  width: 146px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.text_2 {
  width: 177px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.text-wrapper_2 {
  height: 90px;
  background: url(~@/assets/image/ps9ksnoc1cda8a8oal0upx5kvgor6aw4kb02bafcb-532f-4b9d-8655-28e989e52c3d.png) -6px -6px no-repeat;
  background-size: 1345px 103px;
  margin-left: -55px;
  width: 1332px;
}

@font-face {
  font-family: YouSheBiaoTiHei;
  src: url("../assets/youshe.ttf");
}

.text_3 {
  text-shadow: 0px 0px 13px rgba(23, 125, 230, 0.38);
  width: 447px;
  height: 51px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 70px;
  font-family: YouSheBiaoTiHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 70px;
  margin: 20px 0 0 439px;
}

.group_3 {
  width: 288px;
  height: 89px;
  margin: 16px 0 0 8px;
}

.block_1 {
  width: 278px;
  height: 41px;
}

.image_2 {
  width: 82px;
  height: 41px;
  margin: 3px 0 0 -1px;
}

@font-face {
  font-family: PangMenZhengDao;
  src: url("../assets/pangmenzhengdao.ttf");
}

.text_4 {
  width: 170px;
  height: 34px;
  overflow-wrap: break-word;
  color: rgba(13, 204, 255, 1);
  font-size: 45px;
  font-family: PangMenZhengDao;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 46px;
  margin: 4px 0 0 0;
  letter-spacing: -0.05em;
}

.text_5 {
  width: 213px;
  height: 25px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 26px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
  margin: 10px 0 0 500px;
}

.group_4 {
  height: 620px;
  background: url(~@/assets/image/pstnpfejs1wgadyuv7fdi77taor200lhi1f5f26c9b2-3c94-452a-adc2-1cb49e3a4d51.png) 100% no-repeat;
  background-size: 100% 100%;
  width: 1870px;
  position: relative;
  margin: 21px 0 0 25px;
}

.box_2 {
  width: 2015px;
  height: 41px;
  margin: 19px 0 0 20px;
  gap: 20px; /* 添加间距 */
}

.thumbnail_1 {
  width: 15px;
  height: 15px;
  margin: 0; /* 移除原来的margin */
  border: 1px solid #1194bf;
  background-color: #222986;
}


.text_6 {
  width: 56px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 11px 0 0 8px;
}

.thumbnail_2 {
  width: 15px;
  height: 15px;
  margin: 11px 0 0 59px;
}

.text_7 {
  width: 28px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 12px 0 0 8px;
}

.thumbnail_3 {
  width: 14px;
  height: 14px;
  margin: 12px 0 0 60px;
}

.text_8 {
  width: 55px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 11px 0 0 9px;
}

.thumbnail_4 {
  width: 14px;
  height: 14px;
  margin: 12px 0 0 60px;
}

.text_9 {
  width: 54px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 11px 0 0 9px;
}

.thumbnail_5 {
  width: 14px;
  height: 14px;
  margin: 12px 0 0 44px;
}

.text_10 {
  width: 82px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 11px 0 0 9px;
}

.text-wrapper_3 {
  height: 41px;
  background: url(~@/assets/image/psjtr8hvo31vt5v2axc65ibtrsvlgrxo9eddfd6da7-1159-4dc1-8a17-a6644fbb8979.png) 100% no-repeat;
  background-size: 100% 100%;
  margin-left: 400px;
 // margin-left: auto;
  width: 343px;
}

.text_11 {
  width: 284px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin: 11px 0 0 20px;
}

.image-wrapper_1 {
  width: 217px;
  height: 229px;
  margin: 237px 0 94px 856px;
}

.image_3 {
  width: 217px;
  height: 229px;
}

.box_3 {
  height: 518px;
  margin: auto;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.image-wrapper_2 {
  width: 23px;
  height: 26px;
  margin: 138px 0 0 811px;
}

.label_1 {
  width: 23px;
  height: 26px;
}

.image-wrapper_3 {
  width: 22px;
  height: 25px;
  margin: 19px 0 0 811px;
}

.label_2 {
  width: 22px;
  height: 25px;
}

.image-wrapper_4 {
  width: 474px;
  height: 38px;
  margin: 22px 0 0 361px;
}

.label_3 {
  width: 23px;
  height: 26px;
  margin-top: 12px;
}

.label_4 {
  width: 26px;
  height: 23px;
}

.group_5 {
  width: 1468px;
  height: 84px;
  margin: 5px 0 0 359px;
}

.image-wrapper_5 {
  width: 26px;
  height: 70px;
  margin-top: 14px;
}

.label_5 {
  width: 22px;
  height: 25px;
  margin-left: 2px;
}

.label_6 {
  width: 26px;
  height: 23px;
  margin-top: 22px;
}

.label_7 {
  width: 25px;
  height: 25px;
  margin-left: 425px;
}

.label_8 {
  width: 23px;
  height: 26px;
  margin: 36px 0 0 898px;
}

.label_9 {
  width: 22px;
  height: 25px;
  margin: 23px 0 0 49px;
}

.image-wrapper_6 {
  width: 1397px;
  height: 47px;
  margin: 20px 0 0 360px;
}

.label_10 {
  width: 25px;
  height: 25px;
}

.label_11 {
  width: 26px;
  height: 23px;
  margin-top: 24px;
}

.image-wrapper_7 {
  width: 25px;
  height: 25px;
  margin: 20px 0 49px 1732px;
}

.label_12 {
  width: 25px;
  height: 25px;
}

.text-wrapper_4 {
  width: 1464px;
  height: 29px;
  background: url(~@/assets/image/psdeqlx6n0y9cisl59sh81w6yydvdw2h0rc6fa0676-6e64-4cb9-87dd-aa2a71168d6f.png) -1px 0px no-repeat;
  background-size: 1466px 29px;
  margin: 7px 0 0 47px;
}

.text_12 {
  width: 64px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 6px 0 0 125px;
}

.text_13 {
  width: 94px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 6px 0 0 480px;
}

.text_14 {
  width: 111px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 6px 210px 0 380px;
}

.group_6 {
  width: 1751px;
  height: 279px;
  margin: -1px 0 18px 47px;
}

.block_2 {
  width: 1464px;
  height: 279px;
  background: url(~@/assets/image/pss6clonho66onbsv6a9lsgo46f4v0fxb5f65ed0-5fd9-436b-aac4-9514e1661379.png) 100% no-repeat;
  background-size: 100% 100%;
}

.text-wrapper_5 {
  width: 1204px;
  height: 20px;
  margin: 19px 0 0 125px;
}

.text_15 {
  width: 78px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 1px;
}

.text_16 {
  width: 188px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 466px;
}

.text_17 {
  width: 188px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 284px;
}

.text-wrapper_6 {
  width: 1077px;
  height: 23px;
  margin: 16px 0 0 125px;
}

.text_18 {
  width: 147px;
  height: 21px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 2px;
}

.text_19 {
  width: 61px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 397px;
}

.text_20 {
  width: 61px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 411px;
}

.text-wrapper_7 {
  width: 1055px;
  height: 21px;
  margin: 14px 0 0 125px;
}

.text_21 {
  width: 79px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 1px;
}

.text_22 {
  width: 39px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 465px;
}

.text_23 {
  width: 39px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 433px;
}

.text-wrapper_8 {
  width: 1067px;
  height: 20px;
  margin: 17px 0 0 125px;
}

.text_24 {
  width: 79px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_25 {
  width: 40px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 465px;
}

.text_26 {
  width: 50px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 433px;
}

.list_1 {
  width: 1048px;
  height: 57px;
  margin: 17px 0 0 125px;
}

.text-wrapper_9 {
  width: 139px;
  height: 56px;
  margin: 1px 406px 0 0;
}

.text_27 {
  width: 139px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_28 {
  width: 139px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 18px;
}

.text-wrapper_10 {
  width: 1048px;
  height: 20px;
  margin: 17px 0 18px 125px;
}

.text_29 {
  width: 79px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_30 {
  width: 31px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 466px;
}

.text_31 {
  width: 31px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 441px;
}

.block_3 {
  width: 219px;
  height: 261px;
}

.image-text_1 {
  width: 84px;
  height: 27px;
  margin-left: 18px;
}

.label_13 {
  width: 24px;
  height: 27px;
}

.text-group_1 {
  width: 39px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 5px;
}

.section_1 {
  width: 123px;
  height: 26px;
  margin: 18px 0 0 19px;
}

.label_14 {
  width: 22px;
  height: 26px;
}

.text_32 {
  width: 79px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 6px;
}

.image-text_2 {
  width: 126px;
  height: 24px;
  margin: 21px 0 0 16px;
}

.label_15 {
  width: 27px;
  height: 23px;
}

.text-group_2 {
  width: 79px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 5px;
}

.image-text_3 {
  width: 125px;
  height: 28px;
  margin: 18px 0 0 17px;
}

.label_16 {
  width: 26px;
  height: 26px;
}

.text-group_3 {
  width: 79px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 9px;
}

.text-wrapper_11 {
  height: 46px;
  background: url(~@/assets/image/psxjd8k6bz095122v7hna93buoq7xxzj0520db3439-64ca-4762-9dfa-9c7f2cfa399b.png) 100% no-repeat;
  background-size: 100% 100%;
  margin-top: 53px;
  width: 219px;
}

.text_33 {
  text-shadow: 0px -4px 6px rgba(255, 255, 255, 0.56);
  width: 156px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 20px;
  margin: 14px 0 0 27px;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}

body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
  Arial, PingFang SC-Light, Microsoft YaHei;
}

input {
  background-color: transparent;
  border: 0;
}

button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}

button:active {
  opacity: 0.6;
}

.van-nav-bar__left:active,
.van-nav-bar__right:active {
  opacity: 1;
}

[class*="van-"]::after {
  border-bottom: 0;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.justify-start {
  display: flex;
  justify-content: flex-start;
}

.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}

.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}

.justify-around {
  display: flex;
  justify-content: space-around;
}

.justify-between {
  display: flex;
  justify-content: space-between;
}

.align-start {
  display: flex;
  align-items: flex-start;
}

.align-center {
  display: flex;
  align-items: center;
}

.align-end {
  display: flex;
  align-items: flex-end;
}

.image_4 {
  margin: auto;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.checkbox-group {
  gap: 5px; /* 勾选框和文字之间的间距 */
  align-items: center;
}

.svg-wrapper {
  margin-top: 23px;
  width: 100%;
  height: 100%;
  overflow: auto; /* 允许滚动查看超出部分 */
  cursor: grab; /* 使用"抓取"光标提示可交互 */
  position: relative;
  user-select: none; /* 防止拖动时选中文本 */
}

.svg-wrapper:active {
  cursor: grabbing; /* 点击时改变光标 */
}

.svg-container {
  width: 100%;
  height: 516px;
  display: inline-block; /* 重要：保持原始大小，然后应用缩放 */
  position: relative;
  transform: translateZ(0); /* 启用GPU加速 */
}


#drawing-area {
  width: 100%;
  height: 100%;
  display: block;
}

#backImage {
  width: 100%; /* 图片宽度占满 SVG */
  height: 100%; /* 图片高度占满 SVG */
  object-fit: contain; /* 保持图片比例，不拉伸变形 */
}

.text_6, .text_7, .text_9, .text_10 {
  width: auto; /* 改为自动宽度 */
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: SourceHanSansSC-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 0; /* 移除原来的margin */
}



</style>
